module.exports = __webpack_public_path__ + "static/media/012_G6_7Revised Tracklist with Indicator.dd5618e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/012_G6_7Revised Tracklist with Indicator.png
// module id = 437
// module chunks = 0